import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Brain, BarChart3 } from '../components/icons';
import { characteristics } from '../data/characteristics';

const mockScores = characteristics.reduce((acc, char) => {
  acc[char.id] = Math.floor(Math.random() * 30) + 55;
  return acc;
}, {} as Record<string, number>);

export function ExampleResults() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-slate-600 hover:text-teal-600 mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </button>

        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 rounded-full text-amber-700 text-sm font-medium mb-4">
            <BarChart3 className="w-4 h-4" /> Sample Results
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-4">Example Assessment Profile</h1>
          <p className="text-slate-600">This is what your results might look like after completing the assessment.</p>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 mb-8">
          <h2 className="text-xl font-semibold text-slate-900 mb-6">Characteristic Scores</h2>
          <div className="space-y-4">
            {characteristics.map((char, index) => (
              <motion.div key={char.id} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: index * 0.05 }}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-slate-700">{char.name}</span>
                  <span className="text-sm text-slate-500">{mockScores[char.id]}%</span>
                </div>
                <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                  <motion.div initial={{ width: 0 }} animate={{ width: `${mockScores[char.id]}%` }} transition={{ delay: index * 0.05, duration: 0.5 }} className="h-full bg-teal-500 rounded-full" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <button onClick={() => navigate('/register')} className="px-8 py-4 bg-teal-600 text-white rounded-xl font-semibold hover:bg-teal-700 transition-all">
            Take the Full Assessment
          </button>
        </div>
      </div>
    </div>
  );
}
